module.exports = __webpack_public_path__ + "img/HKD.a1f87d69.png";